(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('BankAccountTypeService', BankAccountTypeService)

    /** @ngInject */
    function BankAccountTypeService(HttpService) {
        const BankAccountTypeService = {
            getAll: getAll
        }

        return BankAccountTypeService;

        function getAll() {
            return HttpService.get('/banks/account-types/all');
        }
    }
}());